import { ArrowBack, AttachFile, ExpandMore, Save } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CardHeader, FormControl, FormGroup, Grid, IconButton, Input, InputAdornment, InputLabel, TextField, Tooltip, Typography } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import axios from 'axios';
import { format } from 'date-fns';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import Swal from 'sweetalert2';
import { AuthStore } from '../../../../store/UserStore';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';

const FormKontrak = () => {
    const { setBreadcrumbItem } = useOutletContext();
    const location = useLocation();
    const navigate = useNavigate();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const [loading, setLoading] = useState(false);
    const logOut = AuthStore((state) => state.logOut);
    const pencairan = location.state || null;
    const [reqPdf, setReqPdf] = useState("");
    const [formData, setFormData] = useState({
        no_kontrak: "",
        tgl_kontrak: "",
        no_rek_kegiatan: "",
        pekerjaan: "",
        lokasi: "",
        jumlah_anggaran_dalam_dpa: "",
        jumlah_kontrak: "",
        nomor_spk: "",
        tgl_spk: "",
        tgl_mulai: "",
        tgl_selesai: "",
        nama_perusahaan: "",
        nama_pimpinan: "",
        jabatan: "",
        alamat: "",
        nomor_rekening_bank: "",
        npwp_perusahaan: "",
        file: "",
    });

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/kontrak': 'Kontrak', '': pencairan === null ? 'Tambah' : 'Edit' });
        console.log(pencairan);

        if (pencairan !== null) {
            setFormData({
                _method: 'PUT',
                no_kontrak: pencairan.no_kontrak,
                tgl_kontrak: pencairan.tgl_kontrak,
                no_rek_kegiatan: pencairan.no_rek_kegiatan,
                pekerjaan: pencairan.pekerjaan,
                lokasi: pencairan.lokasi,
                jumlah_anggaran_dalam_dpa: pencairan.jumlah_anggaran_dalam_dpa,
                jumlah_kontrak: pencairan.jumlah_kontrak,
                nomor_spk: pencairan.nomor_spk,
                tgl_spk: pencairan.tgl_spk,
                tgl_mulai: pencairan.tgl_mulai,
                tgl_selesai: pencairan.tgl_selesai,
                nama_perusahaan: pencairan.nama_perusahaan,
                nama_pimpinan: pencairan.nama_pimpinan,
                jabatan: pencairan.jabatan,
                alamat: pencairan.alamat,
                nomor_rekening_bank: pencairan.nomor_rekening_bank,
                npwp_perusahaan: pencairan.npwp_perusahaan,
                file: "",
            });
            setReqPdf(base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/kontrak/' + pencairan.file);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onChangeInput = (e) => {
        if (e.target.name === "jumlah_anggaran_dalam_dpa" || e.target.name === "jumlah_kontrak") {
            formatRupiah(e);
        }
        else {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value
            })
        }
        console.log(formData);
    }

    const formatRupiah = (e) => {
        const nominal = e.target.value;
        const nominalz = nominal.replace(/\./g, '')
        const price = new Intl.NumberFormat('id-ID').format(nominalz);
        setFormData({
            ...formData,
            [e.target.name]: price
        })
    }

    const loadData = event => {
        const file = event.target.files[0];
        console.log(file);
        if (file === undefined || file === "") {
            setFormData({
                ...formData,
                file: ""
            })
        }
        else {
            setFormData({
                ...formData,
                file: file
            })
        }
        console.log(formData);
    }

    const submitForm = () => {
        const isValid = checkForm(formData);
        if (!isValid) {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Isi semua Input'
            })
            return;
        }

        setLoading(true);
        axios.post(
            base_url + '/bnd/kontrak/insert',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                navigate("/bnd/kontrak", { replace: true });
            })
            .catch((error) => {
                console.log(error);
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.data.message
                    })
                }
                setLoading(false)
            })
    }

    const updateData = () => {
        console.log(formData);
        setLoading(true);
        axios.post(
            base_url + '/bnd/kontrak/update',
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${decryptedUser.token}`,
                    'content-type': 'multipart/form-data'
                }
            })
            .then((response) => {
                setLoading(false);

                Swal.fire({
                    icon: 'success',
                    title: 'Berhasil',
                    text: response.data.msg
                })

                navigate("/bnd/kontrak", { replace: true })
            })
            .catch((error) => {
                if (error.response.status === 401 && error.response.data.messages === "Access Token Expired") {
                    logOut();
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.status + ' ' + error.response.statusText
                    })
                }
                setLoading(false)
            })
    }

    function checkForm(obj) {
        for (var key in obj) {
            if (obj[key] === "") {
                console.log("Check Form Salah " + [key]);
                return false;
            }
        }
        console.log("Check Form Benar");
        return true;
    }

    return (
        <Card>
            <CardHeader
                title={
                    <Typography variant='h5'>Kembali</Typography>
                }
                avatar={
                    <Tooltip title="Kembali">
                        <IconButton variant="outlined" onClick={() => {
                            navigate("/bnd/kontrak", { replace: true })
                        }} color="error"><ArrowBack /></IconButton>
                    </Tooltip>
                }
            // subheader="September 14, 2016"
            />
            <CardContent>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='no_kontrak'
                                id="standard-basic"
                                label="Nomor Kontrak"
                                variant="standard"
                                margin="normal"
                                value={formData.no_kontrak}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.no_kontrak === "" ? true : false}
                                inputProps={{
                                    readOnly: (pencairan !== null)
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    disableFuture
                                    label="Tanggal Kontrak"
                                    openTo="day"
                                    inputFormat="yyyy-MM-dd"
                                    value={formData.tgl_kontrak}
                                    onChange={(newValue) => {
                                        setFormData({
                                            ...formData,
                                            tgl_kontrak: format(new Date(newValue), "yyyy-MM-dd")
                                        })
                                        console.log(formData);
                                    }}
                                    renderInput={(params) => <TextField {...params} fullWidth variant="standard" sx={{ mt: 2 }} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='no_rek_kegiatan'
                                id="standard-basic"
                                label="No. Rekening Kegiatan"
                                variant="standard"
                                margin="normal"
                                value={formData.no_rek_kegiatan}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.no_rek_kegiatan === "" ? true : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} justifyContent="center">
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='lokasi'
                                id="standard-basic"
                                label="Lokasi Pekerjaan"
                                variant="standard"
                                margin="normal"
                                value={formData.lokasi}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.lokasi === "" ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <FormControl fullWidth sx={{ mt: 2 }} variant="standard">
                                <InputLabel htmlFor="standard-adornment-amount">Jumlah Anggaran dalam DPA / DPPA</InputLabel>
                                <Input
                                    id="standard-adornment-amount"
                                    value={formData.jumlah_anggaran_dalam_dpa || ''}
                                    onChange={onChangeInput}
                                    startAdornment={<InputAdornment position="start">Rp</InputAdornment>}
                                    name="jumlah_anggaran_dalam_dpa"
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    error={formData.jumlah_anggaran_dalam_dpa === "" || formData.jumlah_anggaran_dalam_dpa === "0" ? true : false}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <FormControl fullWidth sx={{ mt: 2 }} variant="standard">
                                <InputLabel htmlFor="standard-adornment-amount">Nilai Kontrak</InputLabel>
                                <Input
                                    id="standard-adornment-amount"
                                    value={formData.jumlah_kontrak || ''}
                                    onChange={onChangeInput}
                                    startAdornment={<InputAdornment position="start">Rp</InputAdornment>}
                                    name="jumlah_kontrak"
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                    error={formData.jumlah_kontrak === "" || formData.jumlah_kontrak === "0" ? true : false}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={12} sx={{ textAlign: "center" }}>
                            <TextField
                                multiline
                                fullWidth
                                name='pekerjaan'
                                id="standard-basic"
                                label="Pekerjaan"
                                variant="standard"
                                margin="normal"
                                rows={3}
                                value={formData.pekerjaan}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.pekerjaan === "" ? true : false}
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} justifyContent="center">
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='nomor_spk'
                                id="standard-basic"
                                label="Nomor SPK"
                                variant="standard"
                                margin="normal"
                                value={formData.nomor_spk}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.nomor_spk === "" ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    disableFuture
                                    label="Tanggal SPK"
                                    openTo="day"
                                    inputFormat="yyyy-MM-dd"
                                    value={formData.tgl_spk}
                                    onChange={(newValue) => {
                                        setFormData({
                                            ...formData,
                                            tgl_spk: format(new Date(newValue), "yyyy-MM-dd")
                                        })
                                        console.log(formData);
                                    }}
                                    renderInput={(params) => <TextField {...params} fullWidth variant="standard" sx={{ mt: 2 }} />}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormGroup row={true}>
                                <Grid container spacing={2}>
                                    {/* <FormLabel id="demo-row-radio-buttons-group-label">Waktu Pelaksanaan</FormLabel> */}
                                    <Grid item xs={12} md={6}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                // disableFuture
                                                label="Tanggal Mulai Pekerjaan"
                                                openTo="day"
                                                inputFormat="yyyy-MM-dd"
                                                value={formData.tgl_mulai}
                                                onChange={(newValue) => {
                                                    setFormData({
                                                        ...formData,
                                                        tgl_mulai: format(new Date(newValue), "yyyy-MM-dd")
                                                    })
                                                    console.log(formData);
                                                }}
                                                renderInput={(params) => <TextField fullWidth {...params} variant="standard" sx={{ mt: 2 }} />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                            <DatePicker
                                                // disableFuture
                                                label="Tanggal Selesai Pekerjaan"
                                                openTo="day"
                                                inputFormat="yyyy-MM-dd"
                                                value={formData.tgl_selesai}
                                                onChange={(newValue) => {
                                                    setFormData({
                                                        ...formData,
                                                        tgl_selesai: format(new Date(newValue), "yyyy-MM-dd")
                                                    })
                                                    console.log(formData);
                                                }}
                                                renderInput={(params) => <TextField fullWidth {...params} variant="standard" sx={{ mt: 2 }} />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>
                                </Grid>
                            </FormGroup>
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} justifyContent="center">
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='nama_perusahaan'
                                id="standard-basic"
                                label="Nama Perusahaan"
                                variant="standard"
                                margin="normal"
                                value={formData.nama_perusahaan}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.nama_perusahaan === "" ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='nama_pimpinan'
                                id="standard-basic"
                                label="Nama Pimpinan"
                                variant="standard"
                                margin="normal"
                                value={formData.nama_pimpinan}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.nama_pimpinan === "" ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='jabatan'
                                id="standard-basic"
                                label="Jabatan"
                                variant="standard"
                                margin="normal"
                                value={formData.jabatan}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.jabatan === "" ? true : false}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={4} justifyContent="center">
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='alamat'
                                id="standard-basic"
                                label="Alamat"
                                variant="standard"
                                margin="normal"
                                value={formData.alamat}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.alamat === "" ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='nomor_rekening_bank'
                                id="standard-basic"
                                label="Nomor Rekening Bank"
                                variant="standard"
                                margin="normal"
                                value={formData.nomor_rekening_bank}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.nomor_rekening_bank === "" ? true : false}
                            />
                        </Grid>
                        <Grid item xs={12} md={4} sx={{ textAlign: "center" }}>
                            <TextField
                                fullWidth
                                name='npwp_perusahaan'
                                id="standard-basic"
                                label="NPWP Perusahaan"
                                variant="standard"
                                margin="normal"
                                value={formData.npwp_perusahaan}
                                onChange={(e) => onChangeInput(e)}
                                error={formData.npwp_perusahaan === "" ? true : false}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} py={2} justifyContent="center">
                        <Grid item xs={"auto"}>
                            <Button
                                variant="outlined"
                                component="label"
                                startIcon={<AttachFile />}
                                color={
                                    pencairan === null ?
                                        formData.file === "" ? "error" : "primary"
                                        :
                                        "primary"
                                }
                            >
                                File Kontrak
                                <input
                                    hidden
                                    name='file'
                                    accept="application/pdf"
                                    multiple type="file"
                                    onChange={loadData}
                                />
                            </Button>
                        </Grid>
                    </Grid>
                    {formData.file === "" && reqPdf === "" ?
                        "" :
                        <Grid container spacing={2} py={2} justifyContent="center">
                            <Grid item xs={12} md={9} sx={{ textAlign: "center" }}>
                                <Accordion>
                                    <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                        <Typography>File</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <iframe width='100%' height={700} title="Pdf" src={
                                            pencairan === null ?
                                                formData.file === "" ? "" : URL.createObjectURL(formData.file)
                                                :
                                                formData.file === "" ? reqPdf : URL.createObjectURL(formData.file)
                                        } />
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                    }
                    <Grid container spacing={2} py={2} justifyContent="flex-end">
                        <Grid item >
                            <LoadingButton
                                onClick={pencairan === null ? submitForm : updateData}
                                loading={loading}
                                variant="contained"
                                margin="normal"
                                loadingPosition="start"
                                startIcon={<Save />}
                            >
                                {pencairan === null ? "Simpan" : "Update"}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </Box>
            </CardContent>
        </Card>
    )
}

export default FormKontrak